import { render } from "./faecher.vue?vue&type=template&id=b0e16858"
import script from "./faecher.vue?vue&type=script&lang=js"
export * from "./faecher.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Projekte/Seminarplattform/lernplattform-holistic-institut/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__